import React, { lazy, Suspense } from 'react';

const LazyWarrantyRegistrationPage = lazy(() => import('./WarrantyRegistrationPage'));

const WarrantyRegistrationPage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyWarrantyRegistrationPage {...props} />
  </Suspense>
);

export default WarrantyRegistrationPage;
